// Lichtgewicht i18n — geen externe libraries nodig.
// Gebruik: const { t, lang, setLang } = useT(); <h1>{t("nav.designer")}</h1>
import { createContext, useContext, useEffect, useState } from "react";

const LANGS = {
    nl: { code: "nl", flag: "🇧🇪", label: "Nederlands" },
    fr: { code: "fr", flag: "🇫🇷", label: "Français" },
    en: { code: "en", flag: "🇬🇧", label: "English" },
};

const DICT = {
    // Navigation
    "nav.designer":        { nl: "Designer",       fr: "Designer",         en: "Designer" },
    "nav.shirts":          { nl: "T-shirts",       fr: "T-shirts",         en: "T-shirts" },
    "nav.designs":         { nl: "Vaste designs",  fr: "Designs prêts",    en: "Ready designs" },
    "nav.gallery":         { nl: "Galerij",        fr: "Galerie",          en: "Gallery" },
    "nav.stickers":        { nl: "Stickers",       fr: "Autocollants",     en: "Stickers" },
    "nav.bulk":            { nl: "Bulk bestelling",fr: "Commande groupée", en: "Bulk order" },
    "nav.contact":         { nl: "Contact",        fr: "Contact",          en: "Contact" },
    "nav.faq":             { nl: "FAQ",            fr: "FAQ",              en: "FAQ" },
    "nav.cart":            { nl: "Mandje",         fr: "Panier",           en: "Cart" },
    "nav.login":           { nl: "Inloggen",       fr: "Connexion",        en: "Log in" },
    "nav.register":        { nl: "Account aanmaken",fr:"Créer compte",     en: "Sign up" },
    "nav.logout":          { nl: "Uitloggen",      fr: "Déconnexion",      en: "Log out" },
    "nav.myorders":        { nl: "Mijn bestellingen",fr:"Mes commandes",   en: "My orders" },
    "nav.wishlist":        { nl: "Favorieten",     fr: "Favoris",          en: "Wishlist" },
    "nav.saved":           { nl: "Mijn designs",   fr: "Mes designs",      en: "My designs" },

    // Landing hero / CTAs
    "landing.label":       { nl: "Online T-shirt drukker", fr: "Imprimeur T-shirt en ligne", en: "Online T-shirt printer" },
    "landing.title.1":     { nl: "Ontwerp.",       fr: "Conçois.",         en: "Design." },
    "landing.title.2":     { nl: "Druk.",          fr: "Imprime.",         en: "Print." },
    "landing.title.3":     { nl: "Draag.",         fr: "Porte.",           en: "Wear." },
    "landing.sub":         { nl: "Premium B&C t-shirts, hoodies en accessoires. Eigen ontwerp of kant-en-klare designs. Verzending binnen 7 werkdagen.", fr: "T-shirts, hoodies et accessoires B&C premium. Design personnalisé ou prêt à l'emploi. Expédition sous 7 jours ouvrés.", en: "Premium B&C t-shirts, hoodies and accessories. Custom or ready-made designs. Shipping within 7 working days." },
    "landing.cta.design":  { nl: "Start ontwerpen",fr: "Commencer à concevoir",en: "Start designing" },
    "landing.cta.browse":  { nl: "Bekijk catalogus",fr:"Voir catalogue",   en: "Browse catalog" },

    // Trust badges
    "trust.payment":       { nl: "Veilige betaling",      fr: "Paiement sécurisé",      en: "Secure payment" },
    "trust.return":        { nl: "14 dagen retour",       fr: "Retour 14 jours",        en: "14-day returns" },
    "trust.local":         { nl: "Belgisch bedrijf",      fr: "Entreprise belge",       en: "Belgian company" },
    "trust.shipping":      { nl: "Gratis vanaf €75",      fr: "Gratuit dès 75€",        en: "Free over €75" },
    "trust.support":       { nl: "Persoonlijke support",  fr: "Support personnel",      en: "Personal support" },

    // Footer
    "footer.shop":         { nl: "Shop",           fr: "Boutique",         en: "Shop" },
    "footer.help":         { nl: "Hulp",           fr: "Aide",             en: "Help" },
    "footer.legal":        { nl: "Juridisch",      fr: "Légal",            en: "Legal" },
    "footer.terms":        { nl: "Algemene voorwaarden",fr:"CGV",          en: "Terms" },
    "footer.privacy":      { nl: "Privacybeleid",  fr: "Confidentialité",  en: "Privacy" },
    "footer.faq":          { nl: "Veelgestelde vragen",fr:"FAQ",           en: "FAQ" },
    "footer.contact":      { nl: "Contact",        fr: "Contact",          en: "Contact" },
    "footer.rights":       { nl: "Alle rechten voorbehouden.", fr: "Tous droits réservés.", en: "All rights reserved." },
    "footer.contactNote":  { nl: "Onze contactgegevens zijn beschermd tegen scrapers. Bezoek de contactpagina om ze te tonen.", fr: "Nos coordonnées sont protégées contre les scrapers. Visitez la page contact pour les afficher.", en: "Our contact info is protected against scrapers. Visit the contact page to reveal it." },

    // Cart / checkout
    "cart.empty":          { nl: "Je mandje is leeg",fr:"Votre panier est vide",en: "Your cart is empty" },
    "cart.continue":       { nl: "Verder winkelen",fr: "Continuer mes achats",en: "Continue shopping" },
    "cart.total":          { nl: "Totaal",         fr: "Total",            en: "Total" },
    "cart.checkout":       { nl: "Naar afrekenen", fr: "Passer commande",  en: "Checkout" },
    "checkout.title":      { nl: "Afrekenen",      fr: "Paiement",         en: "Checkout" },

    // Reviews
    "reviews.title":       { nl: "Beoordelingen",  fr: "Avis clients",     en: "Reviews" },
    "reviews.empty":       { nl: "Nog geen beoordelingen — wees de eerste!", fr: "Pas encore d'avis — soyez le premier !", en: "No reviews yet — be the first!" },
    "reviews.write":       { nl: "Schrijf een review",fr:"Écrire un avis", en: "Write a review" },
    "reviews.rating":      { nl: "Beoordeling",    fr: "Note",             en: "Rating" },
    "reviews.comment":     { nl: "Jouw ervaring",  fr: "Votre expérience", en: "Your experience" },
    "reviews.submit":      { nl: "Plaats review",  fr: "Publier",          en: "Submit" },
    "reviews.thanks":      { nl: "Bedankt voor je review!", fr: "Merci pour votre avis !", en: "Thanks for your review!" },
    "reviews.loginNeeded": { nl: "Log in om een review te plaatsen", fr: "Connectez-vous pour publier un avis", en: "Log in to leave a review" },

    // FAQ
    "faq.title":           { nl: "Veelgestelde vragen", fr: "Questions fréquentes", en: "Frequently Asked Questions" },
    "faq.sub":             { nl: "Antwoorden op de meest gestelde vragen over ontwerpen, bestellen en verzending.", fr: "Réponses aux questions les plus posées sur la conception, la commande et l'expédition.", en: "Answers to the most asked questions about designing, ordering and shipping." },

    // Common
    "common.loading":      { nl: "Laden…",         fr: "Chargement…",      en: "Loading…" },
    "common.save":         { nl: "Opslaan",        fr: "Enregistrer",      en: "Save" },
    "common.cancel":       { nl: "Annuleren",      fr: "Annuler",          en: "Cancel" },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try {
            const saved = localStorage.getItem("vds_lang");
            if (saved && LANGS[saved]) return saved;
            const browser = (navigator.language || "nl").slice(0, 2).toLowerCase();
            return LANGS[browser] ? browser : "nl";
        } catch { return "nl"; }
    });

    const setLang = (code) => {
        if (!LANGS[code]) return;
        setLangState(code);
        try { localStorage.setItem("vds_lang", code); } catch {}
    };

    useEffect(() => {
        try { document.documentElement.lang = lang; } catch {}
    }, [lang]);

    const t = (key, fallback) => {
        const entry = DICT[key];
        if (!entry) return fallback ?? key;
        return entry[lang] ?? entry.nl ?? key;
    };

    return (
        <I18nCtx.Provider value={{ lang, setLang, t, langs: LANGS }}>
            {children}
        </I18nCtx.Provider>
    );
}

export function useT() {
    const ctx = useContext(I18nCtx);
    if (!ctx) throw new Error("useT must be used within I18nProvider");
    return ctx;
}
